import { useState, useEffect } from "react";
import { SelectedIcon } from "./icons/ApperanceIcon";
import { languages } from "utils/languages";
import { useSelector } from "redux/hooks";
import { updateLanguage } from "redux/actions";
import { useWindowSize } from "hooks/useWindowSize";
interface LanguageSubOptionsProps {
    onSelect?: () => void;
}

export const LanguageSubOptions = ({ onSelect }: LanguageSubOptionsProps) => {
    const [selectedLanguage, setSelectedLanguage] = useState("");
    const { userDetail, theme } = useSelector((state) => state.authReducer);
    const {width} = useWindowSize();
    useEffect(() => {
        const currentLang = userDetail?.user?.language || languages[0].value;
        setSelectedLanguage(currentLang);
    }, [userDetail]);

    const handleLanguageChange = (lang: string) => {
        setSelectedLanguage(lang);
        updateLanguage(lang);


        if (onSelect) {
            onSelect();
        }
    };

    return (
        <div className={`absolute top-0 ml-2 flex p-[12px] flex-col gap-[6px] rounded-[8px] bg-[white] dark:bg-[#252526] shadow-[0_2px_12px_0_rgba(0,0,0,0.25)] z-10 max-h-[208px] overflow-y-auto ${width<850 && width>506 ? "right-full": width<414 ? "left-[58%]":"left-full"} ${width<505 ? "w-[180px]": width<850 ? "w-[248px]": " w-[283px]"}`}>
            {languages.map((language) => (
                <div
                    key={language.value}
                    className="px-1 hover:bg-[#E5E7EB] dark:hover:bg-[#2A3249] rounded-[4px] cursor-pointer"
                    onClick={() => handleLanguageChange(language.value)}
                >
                    <div className="flex items-center justify-between w-full">
                        <div className="flex items-center gap-2">
                            {language.img && (
                                <div className="max-w-[26px] inline-block">
                                    <img src={language.img} alt={language.label} />
                                </div>
                            )}
                            <span className={`font-inter text-[14px] leading-normal font-medium ${selectedLanguage === language.value
                                    ? theme === 'light'
                                        ? 'text-[#4338CA]'
                                        : 'text-[#527AE6]'
                                    : theme === 'light'
                                        ? 'text-[#525252]'
                                        : 'text-[#fff]'
                                }`}>
                                {language.label}
                            </span>
                        </div>
                        {selectedLanguage === language.value && (
                            <span className="flex-shrink-0 leading-[0]">
                                <SelectedIcon theme={theme}/>
                            </span>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
}